import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { Button } from '../components/Button';
import { ArrowLeft } from 'lucide-react';
interface Slide6Props {
  onBack: () => void;
}
export function Slide6({
  onBack
}: Slide6Props) {
  return <SlideLayout footer="¹ Vabysmo® Summary of Product Characteristics (SmPC/RCP), May 2024." progress={{
    current: 3,
    total: 3
  }} onBack={onBack} data-id="element-210">
      <div className="w-full max-w-5xl mx-auto space-y-6" data-id="element-211">
        <h1 className="text-3xl font-bold text-white text-center mb-2 uppercase" data-id="element-212">
          SAFETY OVERVIEW
        </h1>
        <div className="frosted-card rounded-2xl shadow-xl p-8" data-id="element-213">
          <div className="flex items-center justify-center mb-6" data-id="element-214">
            <img src="https://cdn.magicpatterns.com/uploads/a6TaZ8C5KaW5mSvaejmhLU/Screenshot_2026-02-16_at_13.32.32.png" alt="Safety overview - doctor, injection, and eye" className="w-full max-w-lg h-auto rounded-lg shadow-md" data-id="element-215" />
          </div>
          <p className="text-lg text-white text-center leading-relaxed font-medium" data-id="element-216">
            Vabysmo<sup data-id="element-217">®</sup> is administered as an intravitreal injection
            and should be used in accordance with the Summary of Product
            Characteristics.<sup data-id="element-218">¹</sup>
          </p>
        </div>
        <div className="flex justify-center pt-4" data-id="element-219">
          <Button variant="primary" onClick={onBack} data-id="element-220">
            BACK TO MENU
          </Button>
        </div>
      </div>
    </SlideLayout>;
}